
<template>
  <!--Navbar Start-->
  <nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark" id="navbar" :forceBg="forceBg">
    <div class="container">
      <!-- LOGO -->
      <a class="navbar-brand logo text-uppercase" href="/">
        <img src="@/assets/images/logo.svg" id="logo" >
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleMenu()"
      >
        <i class="mdi mdi-menu"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto navbar-center" id="mySidenav" v-scroll-spy-active>
          <li class="nav-item">
            <a v-scroll-to="'#home'" href="javascript: void(0);" class="nav-link">Home</a>
          </li>
          <li class="nav-item">
            <a v-scroll-to="'#services'" href="javascript: void(0);" class="nav-link">Por que contratar?</a>
          </li>
          <li class="nav-item">
            <a v-scroll-to="'#features'" href="javascript: void(0);" class="nav-link">Atendimento Humanizado</a>
          </li>
          <li class="nav-item">
            <a v-scroll-to="'#pricing'" href="javascript: void(0);" class="nav-link">Planos</a>
          </li>
          <!--
          <li class="nav-item">
            <a v-scroll-to="'#team'" href="javascript: void(0);" class="nav-link">Team</a>
          </li>
          <li class="nav-item">
            <a v-scroll-to="'#blog'" href="javascript: void(0);" class="nav-link">Blog</a>
          </li>
          <li class="nav-item">
            <a v-scroll-to="'#contact'" href="javascript: void(0);" class="nav-link">Contact</a>
          </li>
          -->
        </ul>
        <div class="nav-button ml-auto">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <button type="button" class="btn btn-custom navbar-btn btn-rounded waves-effect waves-light" @click="this.$ilimitada.testar">TESTE AGORA DE GRAÇA</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
  <!-- Navbar End -->
</template>

<script>
export default {

  props:{
    forceBg: {
      type: Boolean,
      default: false
    }
  },
  mounted: () => {
    window.onscroll = function () {
      onwindowScroll();
    };
    var navbar = document.getElementById("navbar");

    if(navbar.getAttribute('forcebg')){
        navbar.style.backgroundColor = "#272a33";
    }

    function onwindowScroll() {

      if(!navbar.getAttribute('forcebg')){
        if (
          document.body.scrollTop > 50 ||
          document.documentElement.scrollTop > 50
        ) {
          navbar.style.backgroundColor = "#272a33";
          navbar.style.padding = "10px";
        } else {
          navbar.style.backgroundColor = "";
          navbar.style.padding = "20px";
        }
      } else {


        navbar.style.backgroundColor = "#272a33";

        if (
          document.body.scrollTop > 50 ||
          document.documentElement.scrollTop > 50
        ) {
          navbar.style.padding = "10px";
        } else {
          navbar.style.padding = "20px";
        }
      }

    }
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("navbarCollapse").classList.toggle("show");
    },
  },
};
</script>